import React from "react";

import { Card, CardContent } from "../../components/ui/card";
import InfoTooltip from "../../components/ui/InfoTooltip";
import { Label } from "../../components/ui/label";
import MultipleSelector from "../../components/ui/MultipleSelector";

import ListManager from "../../components/ListManager";

import { projectMetadataOptions } from "../../helpers/projectMetadataHelper";

const ProjectEnvironment = ({ properties, setProperties }) => {
  const updateProperties = async (field, value) => {
    const updatedProperties = {
      ...properties,
      [field]: value,
    };

    setProperties(updatedProperties);
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <ListManager
          items={properties.locations}
          onAdd={(location) =>
            updateProperties("locations", [...properties.locations, location])
          }
          onRemove={(index) =>
            updateProperties(
              "locations",
              properties.locations.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Project locations</Label>

              <div className="relative group">
                <InfoTooltip text="Add locations where your project will be implemented. This helps identify risks specific to each location." />
              </div>
            </div>
          }
          placeholder="Add location..."
        />

        <div className="space-y-2">
          <h4 className="font-medium">
            <div className="flex items-center gap-2 relative">
              <Label>Location types</Label>
            </div>
          </h4>

          <MultipleSelector
            creatable
            defaultOptions={
              projectMetadataOptions.locationTypes.map((locationType) => {
                return { label: locationType, value: locationType };
              }) || []
            }
            value={
              properties.locationTypes.map((locationType) => {
                return { label: locationType, value: locationType };
              }) || []
            }
            onChange={(value) =>
              updateProperties(
                "locationTypes",
                value.map((x) => x.value)
              )
            }
            placeholder={
              properties.locationTypes.length > 0
                ? "Create custom location type..."
                : "Select location types..."
            }
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 relative">
            <Label>Operating Conditions</Label>

            <div className="relative group">
              <InfoTooltip text="Select the operating conditions that apply to your project. This helps identify risks specific to each condition." />
            </div>
          </div>

          <MultipleSelector
            creatable
            defaultOptions={
              projectMetadataOptions.operatingConditions.map(
                (operatingCondition) => {
                  return {
                    label: operatingCondition,
                    value: operatingCondition,
                  };
                }
              ) || []
            }
            value={
              properties.operatingConditions.map((operatingCondition) => {
                return {
                  label: operatingCondition,
                  value: operatingCondition,
                };
              }) || []
            }
            onChange={(value) =>
              updateProperties(
                "operatingConditions",
                value.map((x) => x.value)
              )
            }
            placeholder={
              properties.operatingConditions.length > 0
                ? "Create custom operating condition..."
                : "Select operating conditions..."
            }
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectEnvironment;
